import { useDesign } from '../context/DesignContext';
import TodayViewA from './TodayViewA';
import TodayViewB from './TodayViewB';
import TodayViewC from './TodayViewC';

const views = { A: TodayViewA, B: TodayViewB, C: TodayViewC };

export default function TodayPage() {
  const { design } = useDesign();
  const View = views[design];
  return <View />;
}
